globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.ElementBusinessHours = (function()
{
    function ElementBusinessHours($html) {
      this.$html = $html;
      this.highlightCurrentDay();
    }

    ElementBusinessHours.prototype = {
      highlightCurrentDay: function() {
        var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        var today = new Date();
        var dayName = days[today.getDay()];

        this.$html.find('.element-hours-day.' + dayName).addClass('current-day');
      }
    }

    return ElementBusinessHours;
})();
